import {useGetAndSet} from "./useGetAndSet";
import {createSetCreditNotesDataAction} from "../actions/dataActions";


export const useCreditNotesData = (params, dataFresh) => {
    return useGetAndSet("credit", params, createSetCreditNotesDataAction, dataFresh);
}